export enum ModalTypes {
  // Common
  COMMENT_PREVIEW = 'COMMENT_PREVIEW',
  EXCEL_PREVIEW = 'EXCEL_PREVIEW',
  DOCX_PREVIEW = 'DOCX_PREVIEW',
  PDF_PREVIEW = 'PDF_PREVIEW',
  JSON_PREVIEW = 'JSON_PREVIEW',
  XML_PREVIEW = 'XML_PREVIEW',
  EML_PREVIEW = 'EML_PREVIEW',
  DELETE_DOCUMENT_CONFIRMATION = 'DELETE_DOCUMENT_CONFIRMATION',
  DELETE_SECURITY_MEASURE = 'DELETE_SECURITY_MEASURE',
  DELETE_DEBTOR_STATEMENT = 'DELETE_DEBTOR_STATEMENT',
  // Clients
  CLIENT_APPROVAL = 'CLIENT_APPROVAL',
  CLIENT_DUPLICATE = 'CLIENT_DUPLICATE',
  CLIENT_CONTRACT_DUPLICATE = 'CLIENT_CONTRACT_DUPLICATE',
  FACTORING_CONTRACT_EDIT_SECURITY_MEASURE = 'FACTORING_CONTRACT_EDIT_SECURITY_MEASURE',
  CLIENT_UPDATE_SUPPLIER = 'CLIENT_UPDATE_SUPPLIER',
  LOAN_BOOK_EDIT_SECURITY_MEASURE = 'LOAN_BOOK_EDIT_SECURITY_MEASURE',
  CLIENT_ACTIVATE_LOAN_BOOK_CONTRACT = 'CLIENT_ACTIVATE_LOAN_BOOK_CONTRACT',
  CLIENT_DEBTOR_APPROVE = 'CLIENT_DEBTOR_APPROVE',
  CLIENT_DEBTOR_REJECT = 'CLIENT_DEBTOR_REJECT',
  CLIENT_DEBTOR_CLOSE_RELATIONSHIP = 'CLIENT_DEBTOR_CLOSE_RELATIONSHIP',
  CLIENT_DEBTOR_REQUEST_CLARIFICATION = 'CLIENT_DEBTOR_REQUEST_CLARIFICATION',
  CLIENT_DEBTOR_BILLING_ADDRESS = 'CLIENT_DEBTOR_BILLING_ADDRESS',
  DEBTOR_BLOCK_UNBLOCK = 'DEBTOR_BLOCK_UNBLOCK',
  DEBTOR_UPDATE_RISK_REPORTS = 'DEBTOR_UPDATE_RISK_REPORTS',
  //Risk management
  PROSPECT_REQUEST_APPROVAL = 'PROSPECT_REQUEST_APPROVAL',
  PROSPECT_APPROVE = 'PROSPECT_APPROVE',
  PROSPECT_ARCHIVE = 'PROSPECT_ARCHIVE',
  PROSPECT_REJECT = 'PROSPECT_REJECT',
  PROSPECT_CLOSE = 'PROSPECT_CLOSE',
  PROSPECT_RESET_TO_NEW = 'PROSPECT_RESET_TO_NEW',
  PROSPECT_REQUEST_CLARIFICATION = 'PROSPECT_REQUEST_CLARIFICATION',
  PROSPECT_GENERATE_CONTRACT = 'PROSPECT_GENERATE_CONTRACT',
  CREATE_CLIENT = 'CREATE_CLIENT',
  LEGACY_CREATE_CLIENT = 'LEGACY_CREATE_CLIENT',
  PROSPECT_DEBTOR_REQUEST_APPROVAL = 'PROSPECT_DEBTOR_REQUEST_APPROVAL',
  PROSPECT_DEBTOR_APPROVE = 'PROSPECT_DEBTOR_APPROVE',
  PROSPECT_DEBTOR_REJECT = 'PROSPECT_DEBTOR_REJECT',
  PROSPECT_DEBTOR_CLOSE = 'PROSPECT_DEBTOR_CLOSE',
  PROSPECT_DEBTOR_REQUEST_CLARIFICATION = 'PROSPECT_DEBTOR_REQUEST_CLARIFICATION',
  PROSPECT_CONTRACT_EDIT_SECURITY_MEASURE = 'PROSPECT_CONTRACT_EDIT_SECURITY_MEASURE',
  PROSPECT_CONTRACT_EDIT_DEBTOR_STATEMENT = 'PROSPECT_CONTRACT_EDIT_DEBTOR_STATEMENT',
  ANNUAL_REVIEW_APPROVE = 'ANNUAL_REVIEW_APPROVE',
  ANNUAL_REVIEW_ARCHIVE = 'ANNUAL_REVIEW_ARCHIVE',
  ANNUAL_REVIEW_RESET_TO_NEW = 'ANNUAL_REVIEW_RESET_TO_NEW',
  ANNUAL_REVIEW_REJECT = 'ANNUAL_REVIEW_REJECT',
  ANNUAL_REVIEW_CONTINUE_APPROVAL = 'ANNUAL_REVIEW_CONTINUE_APPROVAL',
  ANNUAL_REVIEW_REQUEST_CLARIFICATION = 'ANNUAL_REVIEW_REQUEST_CLARIFICATION',
  ANNUAL_REVIEW_DEBTOR_APPROVE = 'ANNUAL_REVIEW_DEBTOR_APPROVE',
  ANNUAL_REVIEW_DEBTOR_ARCHIVE = 'ANNUAL_REVIEW_DEBTOR_ARCHIVE',
  ANNUAL_REVIEW_DEBTOR_RESET_TO_NEW = 'ANNUAL_REVIEW_DEBTOR_RESET_TO_NEW',
  ANNUAL_REVIEW_DEBTOR_REJECT = 'ANNUAL_REVIEW_DEBTOR_REJECT',
  ANNUAL_REVIEW_CONTINUE_DEBTOR_APPROVAL = 'ANNUAL_REVIEW_CONTINUE_DEBTOR_APPROVAL',
  ANNUAL_REVIEW_REQUEST_DEBTOR_CLARIFICATION = 'ANNUAL_REVIEW_REQUEST_DEBTOR_CLARIFICATION',
  ANNUAL_REVIEW_CONTRACT_GENERATE_ADDENDUM = 'ANNUAL_REVIEW_CONTRACT_GENERATE_ADDENDUM',
  ANNUAL_REVIEW_CONTRACT_SYNC_TO_FAB = 'ANNUAL_REVIEW_CONTRACT_SYNC_TO_FAB',
  // Factoring - AI Tasks
  AI_TASK_REDO = 'AI_TASK_REDO',
  AI_TASK_ARCHIVE = 'AI_TASK_ARCHIVE',
  AI_TASK_DOCUMENT_ARCHIVE = 'AI_TASK_DOCUMENT_ARCHIVE',
  // Factoring - Notes
  NOTES_UPDATE_PN_FUNDED_DATE = 'NOTES_UPDATE_PN_FUNDED_DATE',
  // Factoring
  INVOICE_ADD_EXTRA_FEES = 'INVOICE_ADD_EXTRA_FEES',
  INVOICE_APPROVE = 'INVOICE_APPROVE',
  INVOICE_ARCHIVE = 'INVOICE_ARCHIVE',
  INVOICE_BUY = 'INVOICE_BUY',
  INVOICE_CLOSE = 'INVOICE_CLOSE',
  INVOICE_CLOSE_WITHOUT_CN = 'INVOICE_CLOSE_WITHOUT_CN',
  INVOICE_BLOCK_CLOSE = 'INVOICE_BLOCK_CLOSE',
  INVOICE_UNBLOCK_CLOSE = 'INVOICE_UNBLOCK_CLOSE',
  INVOICE_FUND = 'INVOICE_FUND',
  INVOICE_MARK_AS_PAID = 'INVOICE_MARK_AS_PAID',
  INVOICE_MARK_AS_REPURCHASED = 'INVOICE_MARK_AS_REPURCHASED',
  INVOICE_PARTLY_FUND = 'INVOICE_PARTLY_FUND',
  INVOICE_REVERT_REPURCHASE = 'INVOICE_REVERT_REPURCHASE',
  INVOICE_REVERT_WRITE_OFF = 'INVOICE_REVERT_WRITE_OFF',
  INVOICE_REJECT = 'INVOICE_REJECT',
  INVOICE_RESET_TO_NEW = 'INVOICE_RESET_TO_NEW',
  INVOICE_SETTLE = 'INVOICE_SETTLE',
  INVOICE_WRITE_OFF = 'INVOICE_WRITE_OFF',
  INVOICE_BULK_EXTERNAL_VERIFICATION_TASK_ARCHIVE = 'INVOICE_BULK_EXTERNAL_VERIFICATION_TASK_ARCHIVE',
  INVOICE_BULK_EXTERNAL_VERIFICATION_TASK_RESEND_EMAILS = 'INVOICE_BULK_EXTERNAL_VERIFICATION_TASK_RESEND_EMAILS',
  // Investment
  INVESTOR_APPROVE = 'INVESTOR_APPROVE',
  INVESTOR_ACTIVATE = 'INVESTOR_ACTIVATE',
  INVESTOR_ARCHIVE = 'INVESTOR_ARCHIVE',
  INVESTOR_RESET_TO_NEW = 'INVESTOR_RESET_TO_NEW',
  INVESTOR_REQUEST_APPROVAL = 'INVESTOR_REQUEST_APPROVAL',
  INVESTOR_EDIT_LEGAL_REPRESENTATIVE = 'INVESTOR_EDIT_LEGAL_REPRESENTATIVE',
  INVESTOR_EDIT_UBO = 'INVESTOR_EDIT_UBO',
  INVESTOR_CANCEL_REINVESTMENT_PLAN = 'INVESTOR_CANCEL_REINVESTMENT_PLAN',
  INVESTOR_REINVESTMENT_PLAN_SEND_NOTIFICATION = 'INVESTOR_REINVESTMENT_PLAN_SEND_NOTIFICATION',
  INVESTOR_REQUEST_INVEST_IN_NEW_OFFER = 'INVESTOR_REQUEST_INVEST_IN_NEW_OFFER',
  INVESTOR_CREATE_NEW_INVESTOR = 'INVESTOR_CREATE_NEW_INVESTOR',
  // System preferences
  SYSTEM_EDIT_CLIENT_USER = 'SYSTEM_EDIT_CLIENT_USER',
  SYSTEM_EDIT_BROKER_USER = 'SYSTEM_EDIT_BROKER_USER',
  SYSTEM_EDIT_INVESTOR_USER = 'SYSTEM_EDIT_INVESTOR_USER',
  SYSTEM_UPDATE_FUNDING_LINE = 'SYSTEM_UPDATE_FUNDING_LINE',
  SYSTEM_EDIT_AI_EMAIL = 'SYSTEM_EDIT_AI_EMAIL',
  SYSTEM_DELETE_AI_EMAIL = 'SYSTEM_DELETE_AI_EMAIL',
  // Payments
  PAYMENTS_RE_OPEN_TRANSACTION = 'PAYMENTS_RE_OPEN_TRANSACTION',
  PAYMENTS_UPDATE_GENERAL_LEDGER = 'PAYMENTS_UPDATE_GENERAL_LEDGER',
  PAYMENTS_WRITE_OFF_TRANSACTION = 'PAYMENTS_WRITE_OFF_TRANSACTION',
  PAYMENTS_REMOVE_TRANSACTION = 'PAYMENTS_REMOVE_TRANSACTION',
  // Loan book
  PRODUCT_REQUEST_APPROVAL = 'PRODUCT_REQUEST_APPROVAL',
  PRODUCT_ARCHIVE = 'PRODUCT_ARCHIVE',
  PRODUCT_DECLINE = 'PRODUCT_DECLINE',
  PRODUCT_CLOSE = 'PRODUCT_CLOSE',
  PRODUCT_RESET_TO_NEW = 'PRODUCT_RESET_TO_NEW',
  PRODUCT_APPROVE = 'PRODUCT_APPROVE',
  PRODUCT_MAKE_PAYOUT = 'PRODUCT_MAKE_PAYOUT',
  PRODUCT_REQUEST_CLARIFICATION = 'PRODUCT_REQUEST_CLARIFICATION',
  PRODUCT_ISSUE_FULL_RETURN_REPORT = ' PRODUCT_ISSUE_FULL_RETURN_REPORT',
  PRODUCT_EDIT_REVERSE_FACTORING_INVOICE = ' PRODUCT_EDIT_REVERSE_FACTORING_INVOICE',
  RESCHEDULE_LOAN_BOOK_TASK = ' RESCHEDULE_LOAN_BOOK_TASK',
  // Risk management
  RISK_MONITORING_TASK_REVIEW = 'RISK_MONITORING_TASK_REVIEW',
  RISK_MONITORING_TASK_ARCHIVE = 'RISK_MONITORING_TASK_ARCHIVE',
  // Client portal
  CLIENT_PORTAL_BILLING_ADDRESS = 'CLIENT_PORTAL_BILLING_ADDRESS',
  CLIENT_PORTAL_EDIT_USER = 'CLIENT_PORTAL_EDIT_USER',
  CLIENT_PORTAL_REQUEST_CLOSE_CLIENT_DEBTOR_RELATIONSHIP = 'CLIENT_PORTAL_REQUEST_CLOSE_CLIENT_DEBTOR_RELATIONSHIP',
  CLIENT_PORTAL_ARCHIVE_INVOICE = 'CLIENT_PORTAL_ARCHIVE_INVOICE',
  CLIENT_PORTAL_FUND_INVOICE = 'CLIENT_PORTAL_FUND_INVOICE',
  CLIENT_PORTAL_PARTLY_FUND_INVOICE = 'CLIENT_PORTAL_PARTLY_FUND_INVOICE',
}
